import { CachedLearningAudio } from '@shared/media/audio/CachedLearningAudio'

import { LegacyYoutubePlayer } from './legacy-youtube-player'
import '../self-study-native.css'

export function MediaBlock({
  audio,
  image,
  title,
  youtubeId,
}: {
  readonly audio?: string
  readonly image?: string
  readonly title?: string
  readonly youtubeId?: string
}) {
  if (!audio && !image && !youtubeId) {
    return null
  }

  return (
    <div className="legacySelfStudyMediaBlock">
      {image ? (
        <img
          alt={title ?? 'Learning media'}
          src={image}
        />
      ) : null}

      {audio ? (
        <CachedLearningAudio
          controls
          preload="metadata"
          src={audio}
        />
      ) : null}

      {youtubeId ? (
        <LegacyYoutubePlayer title={title ?? 'Self-study video'} youtubeId={youtubeId} />
      ) : null}
    </div>
  )
}
